/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type PublishsetsAttachmentsListRequest = {} | null | undefined;
export type PublishsetsAttachmentsListResponse = any;

export type PublishsetsAttachmentsListQuery = {
  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/publishsets_attachments/
 *
 * ```yaml
 * operationId: publishsets_attachments_list
 * tags:
 *   - publishsets_attachments
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const publishsetsAttachmentsListOperation = (
  rest?: PublishsetsAttachmentsListQuery | null,
) =>
  ({
    method: 'GET',
    path: `/dmx-server/publishsets_attachments/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/publishsets_attachments/' };
  };

/**
 * GET /dmx-server/publishsets_attachments/
 *
 * ```yaml
 * operationId: publishsets_attachments_list
 * tags:
 *   - publishsets_attachments
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const publishsetsAttachmentsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PublishsetsAttachmentsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = publishsetsAttachmentsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/publishsets_attachments/
 */
export const usePublishsetsAttachmentsListResource = (
  query: PublishsetsAttachmentsListQuery | null,
  useCached?: boolean,
): UseResource<PublishsetsAttachmentsListResponse> => {
  return useResource<PublishsetsAttachmentsListResponse>({
    path: query === null ? null : publishsetsAttachmentsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
